/* ================================================================
   Palmiye Gurme — arama paneli (Tur 8)
   Markup: sections/header.liquid → 'search' bloğu ([data-pg-search])

   Kutuya tıklanınca (yazı yokken) keşif paneli:
     • Geçmiş aramalar   — ziyaretçinin tarayıcısında (localStorage 'pg:recent-searches'), ilk 3 + "Daha fazla göster"
     • Sana özel ürünler — son gezilen ürüne göre Shopify ürün önerileri (/recommendations/products.json);
                           gezinti yoksa sunucuda basılan koleksiyon (panel ayarı) kalır
     • Popüler aramalar  — panel ayarı (menü veya liste); ilk N tanesi "trend" işaretli
     • Önceden gezdiklerim — ürün sayfası ziyaretleri (localStorage 'pg:recently-viewed'), /products/{handle}.js
   Yazınca (2+ karakter): Shopify tahmine dayalı arama (/search/suggest.json) → öneriler, kategoriler, ürünler.
   Erişilebilirlik: combobox + listbox, ok tuşları / Enter / Esc.
   ================================================================ */
(() => {
  'use strict';

  const RECENT_KEY = 'pg:recent-searches';
  const VIEWED_KEY = 'pg:recently-viewed';
  const CACHE_KEY = 'pg:rv-cache';
  const RECENT_MAX = 10;
  const RECENT_SHOW = 3;
  const VIEWED_MAX = 12;

  const store = {
    get(key, fallback, session) {
      try {
        const raw = (session ? sessionStorage : localStorage).getItem(key);
        return raw ? JSON.parse(raw) : fallback;
      } catch (e) { return fallback; }
    },
    set(key, value, session) {
      try { (session ? sessionStorage : localStorage).setItem(key, JSON.stringify(value)); } catch (e) { /* gizli pencere vb. */ }
    },
  };

  const esc = (str) => String(str == null ? '' : str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function formatMoney(amount, format) {
    // amount: TL cinsinden sayı
    const fmt = format || '{{amount_with_comma_separator}} ₺';
    const fixed = (n, d, ts, ds) => {
      const parts = Number(n).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return parts.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount': return fixed(amount, 2, ',', '.');
        case 'amount_no_decimals': return fixed(amount, 0, ',', '.');
        case 'amount_with_comma_separator': return fixed(amount, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(amount, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fixed(amount, 2, "'", '.');
        case 'amount_with_space_separator': return fixed(amount, 2, ' ', ',');
        default: return fixed(amount, 2, '.', ',');
      }
    });
  }

  // Shopify JSON uçları fiyatı farklı biçimlerde döner: /products/x.js ve öneriler → kuruş (tamsayı),
  // tahmine dayalı arama → "390.00" (metin). İkisi de TL'ye çevrilir.
  const toAmount = (v) => {
    if (v == null || v === '') return null;
    if (typeof v === 'string') return v.includes('.') ? parseFloat(v) : parseInt(v, 10) / 100;
    return v / 100;
  };

  const imgUrl = (src, width) => {
    if (!src) return '';
    const url = typeof src === 'string' ? src : (src.url || src.src || '');
    if (!url) return '';
    const full = url.startsWith('//') ? 'https:' + url : url;
    return full + (full.includes('?') ? '&' : '?') + 'width=' + width;
  };

  function normalizeProduct(p) {
    const price = toAmount(p.price_min != null && typeof p.price_min !== 'string' ? p.price_min : p.price);
    const cmpRaw = p.compare_at_price_min != null && p.compare_at_price_min !== '' ? p.compare_at_price_min : p.compare_at_price;
    const compare = toAmount(cmpRaw);
    return {
      handle: p.handle,
      title: p.title,
      url: p.url || ('/products/' + p.handle),
      image: p.featured_image || (p.image) || (p.images && p.images[0]) || '',
      price,
      compare: compare && price != null && compare > price ? compare : null,
    };
  }

  class PgSearch {
    constructor(root) {
      this.root = root;
      this.d = root.dataset;
      this.form = root.querySelector('form');
      this.input = root.querySelector('[data-pg-search-input]');
      this.reset = root.querySelector('[data-pg-search-reset]');
      this.panel = root.querySelector('[data-pg-search-panel]');
      this.discover = root.querySelector('[data-pg-search-discover]');
      this.results = root.querySelector('[data-pg-search-results]');
      this.backdrop = root.querySelector('[data-pg-search-backdrop]');
      this.header = root.closest('.smart-header');
      this.recentExpanded = false;
      this.discoverLoaded = false;
      this.timer = null;
      this.abort = null;
      this.activeIndex = -1;
      this.sheet = false;
      this.home = null;
      this.mq = window.matchMedia ? window.matchMedia('(max-width: 1023px)') : { matches: false };

      this.recordView();
      this.bind();
    }

    t(key, vars) {
      let s = this.d['t' + key.charAt(0).toUpperCase() + key.slice(1)] || '';
      if (vars) Object.keys(vars).forEach((k) => { s = s.split('%' + k.toUpperCase() + '%').join(vars[k]); });
      return s;
    }

    money(v) { return v == null ? '' : formatMoney(v, this.d.moneyFormat); }

    /* ---------- gezilen ürünü kaydet (ürün sayfasında) ---------- */
    recordView() {
      const h = this.d.currentHandle;
      const id = this.d.currentId;
      if (!h) return;
      const list = store.get(VIEWED_KEY, []).filter((x) => x && x.h !== h);
      list.unshift({ h, id: Number(id) || null });
      store.set(VIEWED_KEY, list.slice(0, VIEWED_MAX));
    }

    /* ---------- olaylar ---------- */
    bind() {
      if (!this.input || !this.panel) return;
      this.input.addEventListener('focus', () => this.onFocus());
      this.input.addEventListener('click', () => { if (this.panel.hidden) this.onFocus(); });
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.form.addEventListener('submit', () => this.saveRecent(this.input.value));
      if (this.reset) this.reset.addEventListener('click', () => { this.input.value = ''; this.onInput(); this.input.focus(); });
      if (this.backdrop) this.backdrop.addEventListener('click', () => this.dismiss());

      this.panel.addEventListener('click', (e) => {
        const clear = e.target.closest('[data-pg-search-recent-clear]');
        if (clear) { store.set(RECENT_KEY, []); this.renderRecent(); this.input.focus(); return; }
        const more = e.target.closest('[data-pg-search-recent-more]');
        if (more) { this.recentExpanded = !this.recentExpanded; this.renderRecent(); return; }
        const del = e.target.closest('[data-pg-search-recent-del]');
        if (del) {
          e.preventDefault();
          const term = del.getAttribute('data-pg-search-recent-del');
          store.set(RECENT_KEY, store.get(RECENT_KEY, []).filter((x) => x !== term));
          this.renderRecent();
          this.input.focus();
          return;
        }
        const term = e.target.closest('[data-search-term]');
        if (term) this.saveRecent(term.getAttribute('data-search-term'));
        const rail = e.target.closest('[data-pg-rail-btn]');
        if (rail) {
          const track = rail.closest('[data-pg-rail]').querySelector('[data-pg-rail-track]');
          const dir = rail.getAttribute('data-pg-rail-btn') === 'next' ? 1 : -1;
          track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        }
      });
      this.panel.addEventListener('scroll', () => {}, { passive: true });
      this.panel.querySelectorAll('[data-pg-rail-track]').forEach((tr) => tr.addEventListener('scroll', () => this.updateRail(tr), { passive: true }));

      this.root.querySelectorAll('[data-pg-search-close]').forEach((b) => b.addEventListener('click', () => this.dismiss()));
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-pg-search-open]')) return;
        if ((this.sheet || !this.panel.hidden) && !this.root.contains(e.target)) this.dismiss();
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && (this.sheet || !this.panel.hidden)) { this.dismiss(); this.input.blur(); } });
      this.mq.addEventListener && this.mq.addEventListener('change', () => { if (!this.mq.matches && this.sheet) this.closeSheet(); });
      window.addEventListener('resize', () => { if (!this.panel.hidden) this.position(); }, { passive: true });
    }

    /* ---------- mobil: ekranın üst yarısını kaplayan arama paneli ---------- */
    openSheet(trigger) {
      if (!this.mq.matches) { this.input.focus(); return; }
      this.trigger = trigger || null;
      if (!this.sheet) {
        // Başlık kaydırmada transform alıyor → panel <body>'ye taşınır ki "position: fixed" ekrana göre çalışsın
        this.home = document.createComment('pg-search');
        this.root.parentNode.insertBefore(this.home, this.root);
        document.body.appendChild(this.root);
        this.sheet = true;
        if (this.backdrop) { document.body.insertBefore(this.backdrop, this.root); this.backdrop.classList.add('is-sheet-backdrop'); this.backdrop.hidden = false; }
        this.root.classList.add('is-sheet');
        this.root.setAttribute('role', 'dialog');
        this.root.setAttribute('aria-modal', 'true');
        document.documentElement.classList.add('pg-search-lock');
        if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
      }
      this.input.focus();
      this.onFocus();
    }

    closeSheet() {
      if (!this.sheet) return;
      this.close();
      this.sheet = false;
      this.root.classList.remove('is-sheet');
      if (this.backdrop) { this.backdrop.classList.remove('is-sheet-backdrop'); this.backdrop.hidden = true; this.root.appendChild(this.backdrop); }
      this.root.removeAttribute('role');
      this.root.removeAttribute('aria-modal');
      document.documentElement.classList.remove('pg-search-lock');
      if (this.home && this.home.parentNode) { this.home.parentNode.insertBefore(this.root, this.home); this.home.remove(); }
      this.home = null;
      if (this.trigger) { this.trigger.setAttribute('aria-expanded', 'false'); this.trigger.focus(); }
    }

    // Esc / dışarı tıklama / kapat: mobil paneldeyse paneli kapatır, değilse yalnızca öneri listesini
    dismiss() { if (this.sheet) this.closeSheet(); else this.close(); }

    onFocus() {
      if (this.input.value.trim().length >= 2) { this.open(); this.search(this.input.value.trim()); return; }
      this.showDiscover();
    }

    onInput() {
      const term = this.input.value.trim();
      if (this.reset) this.reset.hidden = term.length === 0;
      clearTimeout(this.timer);
      if (term.length < 2) {
        if (this.abort) this.abort.abort();
        this.showDiscover();
        return;
      }
      this.timer = setTimeout(() => this.search(term), 180);
    }

    // Panel açıkken başlığı (ve section kapsayıcısını) sayfadaki her şeyin üstüne çıkar:
    // kampanya / bülten açılır pencereleri, sabit çubuklar karartmanın altında kalır.
    raise(on) {
      const els = [this.root.closest('.shopify-section'), this.root.closest('.shopify-section-group-header-group'), this.header].filter(Boolean);
      els.forEach((el) => {
        if (on) {
          if (getComputedStyle(el).position === 'static') { el.dataset.pgPos = '1'; el.style.position = 'relative'; }
          el.classList.add('pg-search-raise');
        } else {
          el.classList.remove('pg-search-raise');
          if (el.dataset.pgPos) { el.style.position = ''; delete el.dataset.pgPos; }
        }
      });
    }

    open() {
      if (!this.sheet) this.raise(true);
      this.position();
      this.panel.hidden = false;
      if (this.backdrop) this.backdrop.hidden = false;
      this.root.classList.add('is-open');
      if (this.header) this.header.classList.add('is-search-open');
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.raise(false);
      this.panel.hidden = true;
      if (this.backdrop && !this.sheet) this.backdrop.hidden = true;
      this.root.classList.remove('is-open');
      if (this.header) this.header.classList.remove('is-search-open');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-activedescendant');
      this.activeIndex = -1;
    }

    // Mobilde panel ekranın altına kadar uzanır (form altından başlayarak)
    position() {
      const r = this.form.getBoundingClientRect();
      this.root.style.setProperty('--pg-search-top', Math.round(r.bottom) + 'px');
    }

    /* ---------- keşif paneli ---------- */
    showDiscover() {
      this.results.hidden = true;
      this.results.innerHTML = '';
      this.renderRecent();
      if (!this.discoverLoaded) { this.discoverLoaded = true; this.loadViewed(); }
      const any = this.discover.querySelector('[data-pg-search-sec]:not([hidden])');
      this.discover.hidden = !any;
      if (any) this.open(); else this.close();
    }

    saveRecent(term) {
      const t = String(term || '').trim();
      if (t.length < 2) return;
      const list = store.get(RECENT_KEY, []).filter((x) => typeof x === 'string' && x.toLocaleLowerCase('tr') !== t.toLocaleLowerCase('tr'));
      list.unshift(t);
      store.set(RECENT_KEY, list.slice(0, RECENT_MAX));
    }

    renderRecent() {
      const wrap = this.root.querySelector('[data-pg-search-recent-wrap]');
      const list = this.root.querySelector('[data-pg-search-recent]');
      const more = this.root.querySelector('[data-pg-search-recent-more]');
      if (!wrap || !list) return;
      const items = store.get(RECENT_KEY, []).filter((x) => typeof x === 'string' && x.trim());
      const shown = this.recentExpanded ? items : items.slice(0, RECENT_SHOW);
      list.innerHTML = shown.map((t) => `
        <li class="pg-search__recent-item">
          <a class="pg-search__recent-link" href="${esc(this.d.searchUrl)}?type=product&amp;options%5Bprefix%5D=last&amp;q=${encodeURIComponent(t)}" data-search-term="${esc(t)}">${esc(t)}</a>
          <button type="button" class="pg-search__recent-del" data-pg-search-recent-del="${esc(t)}" aria-label="${esc(this.t('remove'))}: ${esc(t)}">${this.d.iconClose || '×'}</button>
        </li>`).join('');
      wrap.hidden = items.length === 0;
      if (more) {
        more.hidden = items.length <= RECENT_SHOW;
        more.setAttribute('aria-expanded', this.recentExpanded ? 'true' : 'false');
        const label = more.querySelector('[data-label]');
        if (label) label.textContent = this.recentExpanded ? this.t('showLess') : this.t('showMore');
      }
    }

    card(p, variant) {
      const img = imgUrl(p.image, variant === 'h' ? 120 : 280);
      return `
        <a class="pg-search-card pg-search-card--${variant}" href="${esc(p.url)}">
          <span class="pg-search-card__img">${img ? `<img src="${esc(img)}" alt="" loading="lazy" width="${variant === 'h' ? 60 : 140}" height="${variant === 'h' ? 60 : 140}">` : ''}</span>
          <span class="pg-search-card__body">
            <span class="pg-search-card__title">${esc(p.title)}</span>
            <span class="pg-search-card__price">${p.compare ? `<s>${esc(this.money(p.compare))}</s>` : ''}<b>${esc(this.money(p.price))}</b></span>
          </span>
        </a>`;
    }

    async loadViewed() {
      const viewed = store.get(VIEWED_KEY, []).filter((x) => x && x.h && x.h !== this.d.currentHandle);
      const wrap = this.root.querySelector('[data-pg-search-viewed-wrap]');
      const track = this.root.querySelector('[data-pg-search-viewed]');
      if (!viewed.length) return;

      // 1) Önceden gezdiklerim
      if (wrap && track) {
        const cache = store.get(CACHE_KEY, {}, true);
        const items = await Promise.all(viewed.slice(0, 10).map(async (v) => {
          if (cache[v.h]) return cache[v.h];
          try {
            const res = await fetch(`${this.d.root.replace(/\/$/, '')}/products/${encodeURIComponent(v.h)}.js`, { headers: { Accept: 'application/json' } });
            if (!res.ok) return null;
            const p = normalizeProduct(await res.json());
            cache[v.h] = p;
            return p;
          } catch (e) { return null; }
        }));
        store.set(CACHE_KEY, cache, true);
        const ok = items.filter(Boolean);
        if (ok.length) {
          track.innerHTML = ok.map((p) => this.card(p, 'v')).join('');
          wrap.hidden = false;
          this.updateRail(track);
          if (!this.panel.hidden) this.discover.hidden = false;
        }
      }

      // 2) Sana özel: son gezilen ürüne göre öneriler
      const last = viewed.find((x) => x.id);
      const fyWrap = this.root.querySelector('[data-pg-search-foryou-wrap]');
      const fyTrack = this.root.querySelector('[data-pg-search-foryou]');
      if (!last || !fyWrap || !fyTrack || !this.d.recoUrl) return;
      try {
        const res = await fetch(`${this.d.recoUrl}.json?product_id=${last.id}&limit=10&intent=related`);
        if (!res.ok) return;
        const data = await res.json();
        const seen = new Set(viewed.map((v) => v.h));
        const products = (data.products || []).map(normalizeProduct).filter((p) => !seen.has(p.handle));
        if (products.length) {
          fyTrack.innerHTML = products.map((p) => this.card(p, 'h')).join('');
          fyWrap.hidden = false;
          this.updateRail(fyTrack);
          if (!this.panel.hidden) this.discover.hidden = false;
        }
      } catch (e) { /* öneri yoksa sunucu yedeği kalır */ }
    }

    updateRail(track) {
      const rail = track.closest('[data-pg-rail]');
      if (!rail) return;
      const prev = rail.querySelector('[data-pg-rail-btn="prev"]');
      const next = rail.querySelector('[data-pg-rail-btn="next"]');
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft >= max;
    }

    /* ---------- tahmine dayalı arama ---------- */
    async search(term) {
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'query,product,collection',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag',
      });
      try {
        const res = await fetch(`${this.d.suggestUrl}.json?${params}`, { signal: this.abort.signal, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(String(res.status));
        const data = await res.json();
        this.renderResults(term, (data.resources && data.resources.results) || {});
      } catch (e) {
        if (e.name !== 'AbortError') this.renderResults(term, {});
      }
    }

    highlight(text, term) {
      const safe = esc(text);
      const t = esc(term).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      if (!t) return safe;
      try { return safe.replace(new RegExp(`(${t})`, 'ig'), '<mark>$1</mark>'); } catch (e) { return safe; }
    }

    renderResults(term, r) {
      const queries = (r.queries || []).slice(0, 6);
      const collections = (r.collections || []).slice(0, 4);
      const products = (r.products || []).slice(0, 6).map(normalizeProduct);
      const searchHref = `${esc(this.d.searchUrl)}?type=product&amp;options%5Bprefix%5D=last&amp;q=${encodeURIComponent(term)}`;
      let n = 0;
      const optId = () => `PgSearchOpt-${this.d.uid}-${n++}`;

      const side = [];
      if (queries.length) {
        side.push(`<div class="pg-search__group"><p class="pg-search__group-title">${esc(this.t('suggestions'))}</p><ul class="pg-search__list" role="group">${queries.map((q) => `
          <li><a role="option" id="${optId()}" data-pg-opt class="pg-search__suggestion" href="${esc(this.d.searchUrl)}?type=product&amp;options%5Bprefix%5D=last&amp;q=${encodeURIComponent(q.text)}" data-search-term="${esc(q.text)}">${this.d.iconSearch || ''}<span>${this.highlight(q.text, term)}</span></a></li>`).join('')}</ul></div>`);
      }
      if (collections.length) {
        side.push(`<div class="pg-search__group"><p class="pg-search__group-title">${esc(this.t('categories'))}</p><ul class="pg-search__list" role="group">${collections.map((c) => `
          <li><a role="option" id="${optId()}" data-pg-opt class="pg-search__suggestion" href="${esc(c.url)}"><span>${this.highlight(c.title, term)}</span></a></li>`).join('')}</ul></div>`);
      }
      const main = products.length ? `<div class="pg-search__group"><p class="pg-search__group-title">${esc(this.t('products'))}</p><ul class="pg-search__products" role="group">${products.map((p) => `
          <li>${this.card(p, 'h').replace('<a class="pg-search-card', `<a role="option" id="${optId()}" data-pg-opt class="pg-search-card`)}</li>`).join('')}</ul></div>` : '';

      if (!side.length && !main) {
        this.results.innerHTML = `<p class="pg-search__empty">${esc(this.t('noResults', { terms: term }))}</p>`;
      } else {
        this.results.innerHTML = `
          <div class="pg-search__results-grid${side.length ? '' : ' is-single'}">
            ${side.length ? `<div class="pg-search__results-side">${side.join('')}</div>` : ''}
            ${main ? `<div class="pg-search__results-main">${main}</div>` : ''}
          </div>
          <a class="pg-search__all" role="option" id="${optId()}" data-pg-opt href="${searchHref}" data-search-term="${esc(term)}">${esc(this.t('allResults', { terms: term }))}${this.d.iconArrow || ''}</a>`;
      }
      this.discover.hidden = true;
      this.results.hidden = false;
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
      this.open();
    }

    onKey(e) {
      if (this.panel.hidden || this.results.hidden) return;
      const opts = Array.from(this.results.querySelectorAll('[data-pg-opt]'));
      if (!opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.activeIndex = e.key === 'ArrowDown'
          ? (this.activeIndex + 1) % opts.length
          : (this.activeIndex - 1 + opts.length) % opts.length;
        opts.forEach((o, i) => { o.classList.toggle('is-active', i === this.activeIndex); o.setAttribute('aria-selected', i === this.activeIndex ? 'true' : 'false'); });
        const cur = opts[this.activeIndex];
        this.input.setAttribute('aria-activedescendant', cur.id);
        if (cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.activeIndex >= 0) {
        e.preventDefault();
        const cur = opts[this.activeIndex];
        if (cur.dataset.searchTerm) this.saveRecent(cur.dataset.searchTerm);
        window.location.href = cur.href;
      }
    }
  }

  document.addEventListener('click', (e) => {
    const t = e.target.closest && e.target.closest('[data-pg-search-open]');
    if (!t) return;
    e.preventDefault();
    const el = document.querySelector('[data-pg-search]');
    if (el && el.__pgSearch) el.__pgSearch.openSheet(t);
  });

  const init = () => document.querySelectorAll('[data-pg-search]').forEach((el) => {
    if (el.__pgSearch) return;
    el.__pgSearch = new PgSearch(el);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
